import React from 'react';

const CREDIT_HREF = 'https://shipping.fikrnova.tech/';
const CREDIT_TEXT = 'برمجة وتصميم فكر نوفا لحلول تكنلوجيا المعلومات';

/**
 * Subtle product credit — visible but non-intrusive.
 * @param {'page'|'sidebar'|'dark'} variant
 */
export default function BrandCredit({ variant = 'page', className = '' }) {
  return (
    <div
      className={`vi-brand-credit vi-brand-credit--${variant}${className ? ` ${className}` : ''}`}
      role="contentinfo"
    >
      <a
        href={CREDIT_HREF}
        target="_blank"
        rel="noopener noreferrer"
        title="فكر نوفا لحلول تكنولوجيا المعلومات"
      >
        {CREDIT_TEXT}
      </a>
    </div>
  );
}
